export const ELASTIC_SEARCH_CONSTANTS = {
  MACHINERY_GROUP_ANCESTORS_PROPERTY_NAME: 'ancestors',
  DIRECT_PARENT_MACHINERY_GROUP_PROPERTY_NAME: 'parentMachineryGroupIds',
  ORGANIZATION_ANCESTORS_PROPERTY_NAME: 'organizationAncestors',
  MACHINE_LOCATION_FIELD: 'location',
  MACHINE_CATEGORY_FIELD: 'category',
  TEMPLATE_MACHINE_PROPERTY_NAME: 'templateMachine',
  SEARCH_ITEMS_JOIN: ' AND ',
  MENU_ITEMS_SEARCH_RESULTS_SIZE: 10,
  MENU_ITEMS_SEARCH_TERM_MIN_SIZE: 3,
  PARENT_ID: 'parentId',
  MENU_ITEM_NAME_FIELD: 'name',
  MENU_ITEM_TYPE_FIELD: 'type',
  PAGE_UNDER_MACHINERY_GROUP: 'pageUnderMachineryGroup',
  TEMPLATE_MENU_ITEM_NAME_FIELD: 'name',
  TEMPLATE_MENU_ITEM_REFERENCE_MACHINE_ID_FIELD: 'machineId',
  SPECIAL_CHARACTERS_PATTERN: ['\\+', '\\-', '&&', '\\|\\|', '!', '\\(', '\\)', '{', '}', '\\[', '\\]', '\\^', '"', '~', '\\*', '\\?', ':', '\\\\', '_', ' ']
};
